var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 10,
    viewBox: "0 0 13 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-8.66874e-06 2.46C0.00183957 2.14597 0.0699939 1.83587 0.199992 1.55C0.336272 1.24083 0.558663 0.977413 0.84061 0.791222C1.12256 0.605031 1.45214 0.503933 1.78999 0.5L10.21 0.5C10.5478 0.503933 10.8774 0.605032 11.1594 0.791223C11.4413 0.977413 11.6637 1.24083 11.8 1.55C11.968 1.90574 12.0327 2.30153 11.9868 2.69227C11.9408 3.083 11.786 3.45297 11.54 3.76L7.32999 8.86C7.17077 9.05999 6.9685 9.22151 6.73823 9.33252C6.50796 9.44353 6.25562 9.50118 5.99999 9.50118C5.74436 9.50118 5.49202 9.44353 5.26175 9.33252C5.03148 9.22151 4.82921 9.05999 4.66999 8.86L0.45999 3.76C0.161864 3.39238 -0.000574218 2.93331 -8.66874e-06 2.46Z",
    fill: "#183B56"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.26e03e0d.svg";
export { ForwardRef as ReactComponent };